import { useState } from "react";
import { Check, ChevronsUpDown, Plus } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { cn } from "@/lib/utils";

export const ComboSelect = ({ value, onChange, options, placeholder = "Select or type…", testid }) => {
  const [open, setOpen] = useState(false);
  const [text, setText] = useState("");
  const typed = text.trim();
  const isNew = typed && !options.some((o) => o.toLowerCase() === typed.toLowerCase());
  const pick = (v) => { onChange(v); setOpen(false); setText(""); };
  return (
    <Popover open={open} onOpenChange={setOpen} modal>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testid}
          className="flex h-9 w-full items-center justify-between gap-2 rounded-md border border-input bg-background px-3 text-left text-sm hover:border-primary/60 transition-colors">
          <span className={cn("truncate", !value && "text-muted-foreground")}>{value || placeholder}</span>
          <ChevronsUpDown className="h-4 w-4 shrink-0 opacity-50" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-[--radix-popover-trigger-width] min-w-[260px] p-0" align="start">
        <Command>
          <CommandInput value={text} onValueChange={setText} placeholder="Search or type a new one…" data-testid={`${testid}-search`} />
          <CommandList className="max-h-64">
            <CommandEmpty>{typed ? "No match" : "Nothing saved yet — type a new one"}</CommandEmpty>
            {isNew && (
              <CommandGroup>
                <CommandItem value={`__new__ ${typed}`} onSelect={() => pick(typed)} data-testid={`${testid}-create`}>
                  <Plus className="mr-2 h-4 w-4 text-primary" /> Use “{typed}”
                </CommandItem>
              </CommandGroup>
            )}
            <CommandGroup>
              {value && <CommandItem value="__clear__" onSelect={() => pick("")} data-testid={`${testid}-clear`} className="text-muted-foreground">Clear</CommandItem>}
              {[...new Set((options || []).map((o) => (o ?? "").toString().trim()).filter(Boolean))].map((o) => (
                <CommandItem key={o} value={o} onSelect={() => pick(o)} data-testid={`${testid}-option-${o}`}>
                  <Check className={cn("mr-2 h-4 w-4", value === o ? "opacity-100 text-primary" : "opacity-0")} />
                  <span className="truncate">{o}</span>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
